"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1716],{

/***/ 1716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DetailRoom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9583);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2879);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8352);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9741);
/* harmony import */ var _FormBookNowTop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4580);
/* harmony import */ var _LinkTo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6269);
/* harmony import */ var _SharePopup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1320);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9996);




















function DetailRoom(param1) {
    var _variant = param1.variant, variant = _variant === void 0 ? "smooth" : _variant, _slug = param1.slug, slug = _slug === void 0 ? "" : _slug, _color = param1.color, color = _color === void 0 ? "black" : _color, headline = param1.headline, subHeadline = param1.subHeadline, _images = param1.images, images = _images === void 0 ? [] : _images, title = param1.title, price = param1.price, desc = param1.desc, _featured = param1.featured, featured = _featured === void 0 ? [] : _featured, benefits = param1.benefits, tac = param1.tac, thumb = param1.thumb, includes = param1.includes, layout = param1.layout, brochure = param1.brochure, hotelCode = param1.hotelCode;
    var benefitSplit = function benefitSplit(str) {
        if (str.includes("/")) {
            var temp = str.split("/");
            if (router.locale == "id") return temp[1];
            else return temp[0];
        } else {
            return str;
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isXLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .useLargeQuery */ .fc)().isXLarge;
    var hotels = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useGetListHotel */ .e7)().hotels;
    var newTac = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_13__/* .objParserWP */ .aG)(tac, "item");
    var newIncudes = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_13__/* .objParserWP */ .aG)(includes, "item");
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isSharePop = ref6[0], setIsSharePop = ref6[1];
    var shareButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useOutsideClick */ .O3d)({
        ref: shareButtonRef,
        handler: function() {
            return setIsSharePop(false);
        }
    });
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isModalOpen = ref7[0], setIsModalOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), photoIdx = ref8[0], setPhotoIdx = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isFormOpen = ref9[0], setIsFormOpen = ref9[1];
    var formBookNowRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useOutsideClick */ .O3d)({
        ref: formBookNowRef,
        handler: function() {
            return setIsFormOpen(false);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        variant: variant,
        bg: "white",
        color: color,
        px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .safeMarginX */ .Mp,
        py: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .safeMarginY */ .iM,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 2,
                    as: "h1",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    textAlign: "center",
                    children: headline
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    justify: "space-between",
                    align: "center",
                    w: "100%",
                    mb: 10,
                    color: "blackAlpha.700",
                    fontSize: "small",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: [
                                2,
                                null,
                                1
                            ],
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                align: "center",
                                w: "100%",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    activeColor: "var(--chakra-colors-blackAlpha-500)",
                                    to: "/".concat(slug, "/rooms"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                        align: "center",
                                        gap: 1,
                                        whiteSpace: "nowrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoChevronBack */ .dUf, {}),
                                            router.locale == "id" ? "Kembali ke Halaman Kamar" : "Back to Rooms page"
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                            flex: 1,
                            w: "100%",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                children: subHeadline
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    direction: {
                        base: "column-reverse",
                        lg: "row"
                    },
                    h: "100%",
                    w: "100%",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            w: [
                                "full",
                                null,
                                null,
                                "40%",
                                null,
                                "33%"
                            ],
                            fontSize: "sm",
                            color: "blackAlpha.900",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                    fontSize: "3xl",
                                    letterSpacing: "widest",
                                    fontWeight: 400,
                                    mb: 2,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                    color: "blackAlpha.700",
                                    mb: 2,
                                    display: "none",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_13__/* .formatRupiah */ .b7)(price)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_19__/* .Markup */ .Lu, {
                                    className: "white-space-enter",
                                    content: desc
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                    my: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                                        orientation: "horizontal",
                                        borderColor: "blackAlpha.400"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                    align: "center",
                                    color: "blackAlpha.800",
                                    gap: 6,
                                    my: 3,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                            align: "center",
                                            fontSize: "small",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaUser */ .Xws, {
                                                    color: "inherit",
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                    children: featured[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                            align: "center",
                                            fontSize: "small",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaBed */ .f0S, {
                                                    color: "inherit",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                    children: featured[1]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                            align: "center",
                                            fontSize: "small",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaRulerCombined */ .aVx, {
                                                    color: "inherit",
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                    children: [
                                                        featured[2],
                                                        " m\xb2"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                    position: "relative",
                                    ref: formBookNowRef,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                                            variant: "dark",
                                            bg: color,
                                            mt: 3,
                                            mb: 10,
                                            borderColor: color,
                                            _hover: {
                                                border: "1px solid ".concat(color),
                                                color: color,
                                                bg: "white"
                                            },
                                            onClick: function() {
                                                setIsFormOpen(!isFormOpen);
                                            },
                                            children: router.locale == "id" ? "Pesan" : "Book Now"
                                        }),
                                        isFormOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                            position: "absolute",
                                            w: [
                                                "min(min-content, 360)",
                                                null,
                                                null,
                                                "unset"
                                            ],
                                            top: [
                                                14,
                                                null,
                                                null,
                                                2
                                            ],
                                            left: [
                                                0,
                                                null,
                                                null,
                                                32
                                            ],
                                            ml: [
                                                0,
                                                0,
                                                0,
                                                6
                                            ],
                                            zIndex: 99,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormBookNowTop__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                colorPrimary: color,
                                                hotelCode: hotelCode
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Accordion */ .UQy, {
                                    defaultIndex: [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ],
                                    allowMultiple: true,
                                    color: "blackAlpha.700",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            position: "relative",
                                            _focus: {},
                                            ref: shareButtonRef,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        pl: [
                                                            0,
                                                            null,
                                                            null,
                                                            4
                                                        ],
                                                        _focus: {},
                                                        onClick: function() {
                                                            setIsSharePop(!isSharePop);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaShare */ .Lrt, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: router.locale == "id" ? "Bagikan" : "Share"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                isSharePop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SharePopup__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    isOpen: isSharePop,
                                                    onClose: function() {
                                                        return setIsSharePop(false);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                    pb: 6
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        pl: [
                                                            0,
                                                            null,
                                                            null,
                                                            4
                                                        ],
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaRegFilePdf */ .B$y, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: router.locale == "id" ? "Unduh" : "Downloads"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                    pb: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        gap: 4,
                                                        ml: "1.6rem",
                                                        children: [
                                                            brochure && brochure.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                                                href: "http://docs.google.com/viewerng/viewer?url=".concat(brochure.url),
                                                                isExternal: true,
                                                                children: router.locale == "id" ? "Brosur" : "Brochure"
                                                            }),
                                                            layout && layout.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                                                href: "http://docs.google.com/viewerng/viewer?url=".concat(layout.url),
                                                                isExternal: true,
                                                                children: router.locale == "id" ? "Tata Ruang" : "Layout"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            pt: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        pl: [
                                                            0,
                                                            null,
                                                            null,
                                                            4
                                                        ],
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaUser */ .Xws, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: router.locale == "id" ? "Keuntungan" : "Benefits"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                    py: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                                                        display: "flex",
                                                        flexDir: "column",
                                                        gap: 4,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                                                            columns: 3,
                                                            spacing: 10,
                                                            color: "blackAlpha.600",
                                                            children: [
                                                                ((ref = benefits[0]) === null || ref === void 0 ? void 0 : ref.includes("Shower")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaHandHoldingWater */ .GnP, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[0])
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref1 = benefits[1]) === null || ref1 === void 0 ? void 0 : ref1.includes("Desk")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaLaptop */ .SyT, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[1])
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref2 = benefits[2]) === null || ref2 === void 0 ? void 0 : ref2.includes("LED TV")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaTv */ .RsC, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[2])
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref3 = benefits[3]) === null || ref3 === void 0 ? void 0 : ref3.includes("WI-FI")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaWifi */ ._0, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[3])
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref4 = benefits[4]) === null || ref4 === void 0 ? void 0 : ref4.includes("AC")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaRegSnowflake */ .lCH, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[4])
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref5 = benefits[5]) === null || ref5 === void 0 ? void 0 : ref5.includes("Safety")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    align: "center",
                                                                    gap: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaBox */ .FSC, {
                                                                            size: 20
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                            children: benefitSplit(benefits[5])
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            pt: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        pl: [
                                                            0,
                                                            null,
                                                            null,
                                                            4
                                                        ],
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoRemoveOutline */ .n2U, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: router.locale == "id" ? "Sudah Termasuk" : "Stay Includes"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                    py: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                                                        display: "flex",
                                                        flexDir: "column",
                                                        gap: 4,
                                                        children: newIncudes.map(function(v) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HCh, {
                                                                pl: 2,
                                                                ml: 1,
                                                                children: v
                                                            }, v);
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            pt: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        pl: [
                                                            0,
                                                            null,
                                                            null,
                                                            4
                                                        ],
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoRemoveOutline */ .n2U, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: router.locale == "id" ? "Syarat & Ketentuan" : "Terms & Conditions"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                    py: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                                                        display: "flex",
                                                        flexDir: "column",
                                                        gap: 4,
                                                        children: newTac.map(function(v) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HCh, {
                                                                pl: 2,
                                                                ml: 1,
                                                                children: v
                                                            }, v);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                            flexDir: "column",
                            w: [
                                "full",
                                null,
                                null,
                                "60%",
                                null,
                                "66%"
                            ],
                            h: "100%",
                            gap: 6,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                    position: "relative",
                                    w: "100%",
                                    h: [
                                        "50vh",
                                        null,
                                        "60vh",
                                        "65vh"
                                    ],
                                    className: "section-swiper-v2",
                                    children: images.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_11__/* .Swiper */ .tq, {
                                        centeredSlides: true,
                                        loop: images.length > 1,
                                        pagination: {
                                            clickable: true
                                        },
                                        autoplay: {
                                            delay: 8000,
                                            pauseOnMouseEnter: true,
                                            disableOnInteraction: true
                                        },
                                        modules: images.length > 1 ? [
                                            swiper__WEBPACK_IMPORTED_MODULE_9__/* .Autoplay */ .pt,
                                            swiper__WEBPACK_IMPORTED_MODULE_9__/* .Pagination */ .tl
                                        ] : [],
                                        children: images.map(function(param, i) {
                                            var url = param.url, id = param.id;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_11__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                    w: "100%",
                                                    h: "100%",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    onClick: function() {
                                                        setIsModalOpen(true);
                                                        setPhotoIdx(i);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        alt: "",
                                                        src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_13__/* .convertImgHttps */ .Nu)(url),
                                                        layout: "fill",
                                                        objectFit: "cover",
                                                        priority: true,
                                                        unoptimized: true
                                                    })
                                                })
                                            }, id);
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                        h: "100%",
                                        w: "100%",
                                        color: color,
                                        opacity: 0.2
                                    })
                                }),
                                isModalOpen && images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    mainSrc: images[photoIdx].url,
                                    nextSrc: images[(photoIdx + 1) % images.length],
                                    prevSrc: images[(photoIdx + images.length - 1) % images.length],
                                    onCloseRequest: function() {
                                        return setIsModalOpen(false);
                                    },
                                    onMovePrevRequest: function() {
                                        return setPhotoIdx((photoIdx + images.length - 1) % images.length);
                                    },
                                    onMoveNextRequest: function() {
                                        return setPhotoIdx((photoIdx + 1) % images.length);
                                    }
                                }),
                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                    position: "relative",
                                    w: "100%",
                                    h: "65vh",
                                    children: thumb ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: thumb,
                                        alt: "",
                                        layout: "fill",
                                        objectFit: "cover",
                                        priority: true,
                                        unoptimized: true
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                        h: "100%",
                                        w: "100%",
                                        color: color,
                                        opacity: 0.2
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharePopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);






function SharePopup(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), currentUrl = ref[0], setCurrentUrl = ref[1];
    var ref1 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useClipboard */ .VPI)(currentUrl), hasCopied = ref1.hasCopied, onCopy = ref1.onCopy;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    var facebookURL = "https://www.facebook.com/sharer/sharer.php?u=".concat(currentUrl);
    var whatsAppURL = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(currentUrl));
    var handleFacebookShare = function() {
        if (true) {
            window.open(facebookURL, "_blank");
        }
    };
    var handleWhatsAppShare = function() {
        if (true) {
            window.open(whatsAppURL, "_blank");
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        bg: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "9999",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            bg: "white",
            borderRadius: "md",
            p: 6,
            maxWidth: "400px",
            width: "90%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                    position: "absolute",
                    top: 2,
                    right: 2,
                    onClick: onClose,
                    variant: "ghost",
                    size: "sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoClose */ .bjh, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    fontSize: "lg",
                    fontWeight: "bold",
                    mb: 4,
                    children: "Share this page"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 3,
                    mb: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoFacebook */ .egd, {}),
                            colorScheme: "facebook",
                            onClick: handleFacebookShare,
                            flex: 1,
                            children: "Facebook"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoWhatsapp */ .ff9, {}),
                            colorScheme: "whatsapp",
                            bg: "#25D366",
                            _hover: {
                                bg: "#128C7E"
                            },
                            onClick: handleWhatsAppShare,
                            flex: 1,
                            children: "WhatsApp"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                            value: currentUrl,
                            readOnly: true,
                            placeholder: currentUrl,
                            flex: 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdContentCopy */ .Fqs, {}),
                            onClick: onCopy,
                            colorScheme: hasCopied ? "green" : "gray",
                            children: hasCopied ? "Copied!" : "Copy"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

}]);